// src/components/auth/RutaPrivada.jsx
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { usuario } = useContext(AuthContext);

  if (!usuario) {
    return <Navigate to="/auth/login" />;
  }

  return children;
};

export default PrivateRoute;